import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  User,
  AccountWorkflow,
} from "../../../models";
import {
  CurrentUserService,
  UserAuthenticationService,
} from "../../../services/shared";
import { NgProgressService } from "ng2-progressbar";
import { USERHOMECONSTANTS } from "../../../modules/userHome";
import { WORKFLOWCONSTANTS } from "../workflow.constants";
import { AccountWorkflowService } from "./accountWorkflow.service";
const _ = require("underscore");
const swal = require("sweetalert2");

@Component({
  selector: "accountWorkflow-component",
  template: require("./accountWorkflow.component.html"),
  styles: [require("./accountWorkflow.component.less").toString()],
  providers: [AccountWorkflowService],
})
export class AccountWorkflowComponent implements OnInit {
  @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
  @Output() handleRejectProcessing: EventEmitter<any> = new EventEmitter();
  workflowAccountDetails = new User();
  accountWorkflow: AccountWorkflow;
  workflowTaskId: string;
  errorMessage: string;
  errors: Error[];
  loggedIn: boolean = false;
  isProcessing: boolean;
  isRejectProcessing: boolean;
  hasEditPermission: boolean;

  constructor(
    private currentUserService: CurrentUserService,
    private userAuthService: UserAuthenticationService,
    private cecRouter: Router,
    private cecActivatedRoute: ActivatedRoute,
    private pService: NgProgressService,
    private accountWorkflowService: AccountWorkflowService
  ) {}

  /// #region - event handlers

  ngOnInit() {
    this.isProcessing = false;
    this.isRejectProcessing = false;
    if (!this.userAuthService.isAuthenticated) {
      this.cecRouter.navigate(["/login"]);
      return;
    }
    this.errorMessage = "";
    // Apply security rules
    // Global admins, diocesan admin and organisation admin can edit
    this.hasEditPermission =
      this.currentUserService.IsGlobalAdmin() ||
      this.currentUserService.IsDiocesanAdmin() ||
      this.currentUserService.IsOrgAdmin();

    if (!this.hasEditPermission) {
      this.errorMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
      return;
    }
    // Start processing
    this.pService.start();
    this.accountWorkflow = new AccountWorkflow();
    this.workflowTaskId = this.cecActivatedRoute.snapshot.params[
      WORKFLOWCONSTANTS.params.taskId
    ];
    if (this.workflowTaskId) {
      this.accountWorkflow.taskId = this.workflowTaskId;
      this.getAccountWorkflowByTaskId(this.workflowTaskId);
    }
  }

  onAccountApprove() {
    this.errorMessage = "";
    this.errors = [];
    this.submitApproveRequest(this);
  }

  onAccountReject() {
    this.errorMessage = "";
    this.errors = [];
    this.submitRejectRequest(this);
  }

  onGoBack() {
    this.goBackToTasks();
  }

  onHandleProcessing(isProcessing) {
    this.isProcessing = isProcessing;
  }

  onHandleRejectProcessing(isRejectProcessing) {
    this.isRejectProcessing = isRejectProcessing;
  }

  /// #endregion - event handlers

  /// #region - functions

  goBackToTasks(): void {
    let tabId = this.cecActivatedRoute.snapshot.queryParams[
      USERHOMECONSTANTS.params.tabId
    ];
    if (!tabId) {
      tabId = USERHOMECONSTANTS.tabIds.tasksId;
    }
    let navigationExtras = {
      queryParams: { tabId: tabId },
    };
    this.cecRouter.navigate(["/myhome"], navigationExtras);
  }

  submitApproveRequest(accountWorkflowComponent: AccountWorkflowComponent) {
    swal({
      title: "Are you sure?",
      text: "You want to approve this account.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(
      function () {
        accountWorkflowComponent.processApproveRequest();
      },
      function (dismiss) {}
    );
  }

  processApproveRequest() {
    this.pService.start();
    this.errorMessage = "";
    this.isProcessing = true;
    this.handleProcessing.emit(true);
    this.accountWorkflow.accountStatusCode =
      USERHOMECONSTANTS.accountStatus.active;
    this.accountWorkflowService
      .submitAccountWorkflow(this.accountWorkflow)
      .subscribe(
        (response: boolean) => {
          if (response === true) {
            swal(
              "Done!",
              USERHOMECONSTANTS.messages.requestSuccessfull,
              "success"
            );
          } else {
            swal("Failed!", USERHOMECONSTANTS.messages.requestFailed, "error");
          }
          this.goBackToTasks();
        },
        (error) => {
          let paersedErrors = JSON.parse(error._body);
          this.errorMessage = USERHOMECONSTANTS.messages.requestFailed;
          if (paersedErrors) {
            paersedErrors.message = this.errorMessage;
            let popupMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
            this.errors = paersedErrors.errors;
            if (this.errors) {
              popupMessage = this.errors[0].message;
            }
            swal(paersedErrors.message, popupMessage, "error");
          }
        }
      )
      .add((t) => {
        this.isProcessing = false;
        this.handleProcessing.emit(false);
        this.pService.done();
      });
  }

  submitRejectRequest(accountWorkflowComponent: AccountWorkflowComponent) {
    swal({
      title: "<h3>Reason for rejecting the account</h3>",
      text: accountWorkflowComponent.accountWorkflow.comment,
      type: "warning",
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      animation: "slide-from-top",
      inputPlaceholder: "Comment on rejection",
      preConfirm: function (inputValue) {
        return new Promise(function (resolve, reject) {
          if (!inputValue) {
            reject("Your comment is required!");
          } else {
            resolve();
          }
        });
      },
      allowOutsideClick: false,
    }).then(
      function (inputValue) {
        accountWorkflowComponent.accountWorkflow.comment = inputValue;
        accountWorkflowComponent.processRejectRequest();
      },
      function (dismiss) {}
    );
  }

  processRejectRequest() {
    this.pService.start();
    this.errorMessage = "";
    this.isRejectProcessing = true;
    this.handleRejectProcessing.emit(true);
    this.accountWorkflow.accountStatusCode =
      USERHOMECONSTANTS.accountStatus.inActive;
    this.accountWorkflowService
      .submitAccountWorkflow(this.accountWorkflow)
      .subscribe(
        (response: boolean) => {
          if (response === true) {
            swal(
              "Done!",
              USERHOMECONSTANTS.messages.requestSuccessfull,
              "success"
            );
          } else {
            swal("Failed!", USERHOMECONSTANTS.messages.requestFailed, "error");
          }
          this.goBackToTasks();
        },
        (error) => {
          let paersedErrors = JSON.parse(error._body);
          this.errorMessage = USERHOMECONSTANTS.messages.requestFailed;
          if (paersedErrors) {
            paersedErrors.message = this.errorMessage;
            let popupMessage = USERHOMECONSTANTS.messages.requestUnauthorised;
            this.errors = paersedErrors.errors;
            if (this.errors) {
              popupMessage = this.errors[0].message;
            }
            swal(paersedErrors.message, popupMessage, "error");
          }
        }
      )
      .add((t) => {
        this.isRejectProcessing = false;
        this.handleRejectProcessing.emit(false);
        this.pService.done();
      });
  }

  getAccountWorkflowByTaskId(taskId: string): void {
    this.accountWorkflowService
      .getAccountWorkflowByTaskId(taskId)
      .subscribe(
        (accountResponse: User) => {
          if (accountResponse) {
            accountResponse.organisations = _.sortBy(
              accountResponse.organisations,
              "name"
            );
              this.workflowAccountDetails = accountResponse;

              this.accountWorkflow.userId = accountResponse.userId; //Added
              this.accountWorkflow.accountId = accountResponse.accountId; //Added
          }
        },
        (error) => {
          let paersedErrors = JSON.parse(error._body);
          if (paersedErrors) {
              this.errorMessage = paersedErrors.message;
              this.errors = paersedErrors.errors;
              let popupMessage = "Task has been completed and no longer valid!";
              if (this.errors) {
                  popupMessage = this.errors[0].message;
              }
              swal({
                title: "Task",
                text: popupMessage,
                type: "warning"
              });

              this.onGoBack();
          }
      })
      .add(() => {
        this.pService.done();
      });
  }

  /// #endregion - functions
}



// WEBPACK FOOTER //
// ./src/app/modules/workflow/account/accountWorkflow.component.ts